import { Component, h, Prop } from "@stencil/core"
import LanguageHandler from "@payair/e-com-common-sdk/core/LanguageHandler"
import { getSupportedLocaleData, getLanguageHandler } from "../../languageHandler/LanguageHandler"

/**
 * Component containing a clickable text for switching user.
 */
@Component({
  tag: "switch-user",
  styleUrl: "SwitchUser.scss",
})
export class SwitchUser {
  /**
   * Merchant site preferred locale. Format based on ISO format for language (ISO 639-1) and country code
   * (ISO 3166-1 alpha-2). The language and country should be separated using an underscore ( _ ).
   * <br /><br />
   * **Supported locale**: en_GB, sv_SE, pl_PL
   * <br /><br />
   * @default en_GB
   */
  @Prop() locale?: string

  /**
   * User login value to diplay it on the screen.
   */
  @Prop() userCredentials: string

  /**
   * Clickable text displayed on the screen
   *
   * @default "Not you?"
   */
  @Prop() switchUserText?: string

  /**
   * Callback called after clickable text click.
   */
  @Prop() changeUserButtonOnClick: () => void

  private languageHandler: LanguageHandler

  componentWillLoad() {
    const supportedLang = getSupportedLocaleData(this.locale).lang
    this.languageHandler = getLanguageHandler(supportedLang)
  }

  render() {
    return (
      <div class="switchContainer">
        <label class="userEmail">{this.userCredentials}</label>
        <label class="userChange" onClick={this.changeUserButtonOnClick}>
          {this.switchUserText ? this.switchUserText : this.languageHandler.getString("notYou")}
        </label>
      </div>
    )
  }
}
